<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-category-detail
      [category]="category"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedCategory)="onSavedCategory($event)"
      (canceledCategory)="onCanceledCategory()"
    ></app-category-detail>
  </div>
</div>
